import { useState } from 'react';

const ImportTrayDetailsPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showImportPopup, setShowImportPopup] = useState<boolean>(false);

    const addToggleHandler = () => {
      setShowImportPopup(!showImportPopup);
    };

    return (
      <Component
        showImportPopup={showImportPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default ImportTrayDetailsPopupHOC;
